
// Coordinates for highlighting matching lines in the PDF
export const highlightMatchingLines = (lines, searchQuery, setHighlightCoords) => {
    if (!searchQuery || searchQuery.trim() === "") {
        setHighlightCoords([]);
        return;
    }
    const matchingCoords = [];
    lines.forEach((line) => {
        if (line.text.toLowerCase().includes(searchQuery.toLowerCase())) {
            matchingCoords.push(line.coord.flat());
        }
    });
    setHighlightCoords(matchingCoords);
};

// Highlight matching search terms in the text
export const highlightText = (text, searchTerm) => {
    // Handle null/undefined text
    if (!text) return text;
    if (!searchTerm || searchTerm.trim() === "") return text;

    // Escape special characters in the search string for use in regex
    const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escapedSearchTerm})`, "gi");

    const parts = text.split(regex);
    // Create a non-global regex for testing individual parts
    const testRegex = new RegExp(`^${escapedSearchTerm}$`, "i");

    return parts.map((part, index) =>
        testRegex.test(part) ? (
            <span key={index} className="highlight">
                {part}
            </span>
        ) : (
            part
        )
    );
};

// Download a text file with the given content
export const downloadTextFile = (content, filename) => {
    if (!content) {
        console.warn("No content to download.");
        return;
    }

    // Create a Blob with the text content
    const blob = new Blob([content], { type: "text/plain" });

    // Create a downloadable link
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
};

export const generateArabicTranscript = (arabicText) => {
    return `=== Arabic Script ===\n\n${arabicText}`;
};

export const generateTranslatedTranscript = (translatedText, language) => {
    return `=== Translated (${language.toUpperCase()}) ===\n\n${translatedText}`;
};
